import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const muniname = (muni) => {
    return muni ? _jsxs(_Fragment, { children: [_jsx("span", { className: "kommune-navn", children: muni.kommune_navn }), _jsx(_Fragment, { children: " " }), _jsx("span", { className: "kommune-benevnelse", children: muni.kommune_benevnelse.toLocaleLowerCase() })] })
        : _jsx(_Fragment, {});
};
